import { render } from "./index.vue?vue&type=template&id=b043fc72"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\11710\\Desktop\\admin-box-vue-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__